import React from "react";

import { GroupsPanel, ProductsPanel } from "features/Catalog";

import styles from "./styles.module.scss";

export const MainPage = () => (
  <div className={styles.page}>
    <GroupsPanel />
    <ProductsPanel />
  </div>
);
